// Récupérer la wishlist depuis localStorage
function getWishlist() {
  let wishlist = localStorage.getItem('wishlist');
  return wishlist ? JSON.parse(wishlist) : [];
}

// Ajouter ou retirer un produit de la wishlist
function toggleWishlist(productHandle) {
  let wishlist = getWishlist();
  if (wishlist.includes(productHandle)) {
    wishlist = wishlist.filter(handle => handle !== productHandle);
  } else {
    wishlist.push(productHandle);
  }
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
  updateButtons();
}

// Mettre à jour le texte des boutons
function updateButtons() {
  const wishlist = getWishlist();
  document.querySelectorAll('.wishlist-button').forEach(button => {
    const handle = button.getAttribute('data-product-handle');
    if (wishlist.includes(handle)) {
      button.textContent = '💔 Retirer de la wishlist';
    } else {
      button.textContent = '❤️ Ajouter à ma wishlist';
    }
  });
}

// Initialisation des boutons
document.addEventListener('DOMContentLoaded', () => {
  updateButtons();
  document.querySelectorAll('.wishlist-button').forEach(button => {
    button.addEventListener('click', () => {
      const handle = button.getAttribute('data-product-handle');
      toggleWishlist(handle);
    });
  });
});

